import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Heading from "../ui/Heading";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { isDesktop } from "react-device-detect";

const DesignDiamondRing = () => {
  const settings = {
    customPaging: function (i) {
      return <a className="dots11">{i + 1}</a>;
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <section className="RingBuilderHome design-diamond-ring-section">
     {isDesktop ? 
     <Container fluid className="showcase-container">
            <div className="textBox">
              <Heading className="text-start p-0">
                <span>Design Your Own</span>
                <h2>Diamond Ring</h2>
                <p>
                Design a diamond ring that reflects
                your style and personality
                </p>
                <div className="content mt-4">
                  <Link
                    to="/ringsettings"
                    className="f__btn_green mr-3"
                  >
                    Start with a setting
                  </Link>
                  <Link to="/diamonds" className="f__btn_green notActive">
                    Start with a diamond{" "}
                  </Link>
                </div>
              </Heading>
              </div>
         
      </Container>
      : 
      <>
      <div className="textBox">
              <Heading className="text-start p-0">
                <span>Design Your Own</span>
                <h2>Diamond Ring</h2>
                <p>
                Design a diamond ring that reflects
                your style and personality
                </p>
                <div className="content mt-4">
                  <Link
                    to="/ringsettings"
                    className="f__btn_green mr-3"
                  >
                    Start with a setting
                  </Link>
                  <Link to="/diamonds" className="f__btn_green notActive">
                    Start with a diamond{" "}
                  </Link>
                </div>
              </Heading>
              </div>
      </>
}
    </section>
  );
};

export default DesignDiamondRing;
